// extracted by mini-css-extract-plugin
export default {"container":"page-card_container__uO5bF","truncate-table":"page-card_truncate-table__T29rq","table-text-faded":"page-card_table-text-faded__Fd4qO","overview":"page-card_overview__PcHio","isForm":"page-card_isForm__ruPMf"};
    if(module.hot) {
      // 1792500639461
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  